module.exports = __webpack_public_path__ + "img/gift_banner_char.0d11e3fb.png";